import React from 'react';
import {
 IconCircleDashed,
 IconUsers,
 IconRocket,
 IconCurrencyDollar,
 IconCheck
} from '@tabler/icons-react';
import CampaignCard from './CampaignCard';

const STAGE_ICONS = {
 waiting_to_start: IconCircleDashed,
 recruitment: IconUsers,
 live: IconRocket,
 payment_report: IconCurrencyDollar,
 finished: IconCheck,
};

const MobileCampaignList = ({ stage, campaigns, summaries = {}, onCampaignClick, onCampaignSettings, canManageCampaigns = true }) => {
 const IconComponent = STAGE_ICONS[stage];

 return (
 <div className="w-full h-full flex flex-col overflow-hidden">
 <div className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-hide px-3 py-3">
 {campaigns.length === 0 ? (
 <div className="text-center border border-dashed border-glass-border bg-surface-1/50 p-8">
 {IconComponent && (
 <IconComponent size={40} strokeWidth={1.5} className="text-text-tertiary/40 mb-3 mx-auto" />
 )}
 <p className="text-sm font-medium text-text-tertiary">
 No campaigns in this stage
 </p>
 </div>
 ) : (
 campaigns.map((campaign, index) => (
 <div
 key={campaign._id}
 className={index < campaigns.length - 1 ? 'mb-3' : ''}
 >
 <CampaignCard
 campaign={{ ...campaign, operationalSummary: summaries[String(campaign._id)] }}
 stage={stage}
 onClick={onCampaignClick}
 onSettingsClick={onCampaignSettings}
 isMobile={true}
 canManageCampaigns={canManageCampaigns}
 />
 </div>
 ))
 )}
 </div>
 </div>
 );
};

export default MobileCampaignList;
